export function makeImmutable(obj) {
    Object.freeze(obj);
}
